import { type ReactNode, useContext } from "react";
import { Redirect, useLocation, useParams, useRouteMatch } from "react-router";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";

import { routes } from "utilities/routes";

interface ISpecificationBookRedirectProps {
    /** Renders the Book View. Called only when the viewer stays on it. */
    renderBookView: () => ReactNode;
}

/**
 * The internal Book View routes. With the SpecificationGroups flag the Book View is retired for every
 * persona, so a Book link (a notification, an old email, a bookmark) is sent to the List route with the
 * same spec open. Everything else in the URL carries over: a nested route under the Book path (a linked
 * item's modal), the query string (`?commentId`, `?action=new`), the hash and the location state. Without
 * the flag, everyone stays on the Book View.
 */
export function SpecificationBookRedirect({
    renderBookView,
}: Readonly<ISpecificationBookRedirectProps>) {
    const builderInfo = useContext(BuilderInfoContext);
    const { externalId } = useParams<{ externalId?: string }>();
    const location = useLocation();
    const match = useRouteMatch();

    if (builderInfo?.flags.specificationGroups === true) {
        const nestedPath = location.pathname.slice(match.url.length);
        return (
            <Redirect
                to={{
                    ...location,
                    pathname: routes.specification.getListLink(externalId) + nestedPath,
                }}
            />
        );
    }

    return <>{renderBookView()}</>;
}
